import React from "react";
import service1 from "../../assets/images/service1.png";
import service2 from "../../assets/images/service2.png";
import service3 from "../../assets/images/service3.png";
import service4 from "../../assets/images/service4.png";

const SERVICES = [
  {
    icon: service1,
    title: "Muscle Care",
    desc: "Relieves pain and improves circulation with targeted, therapist-guided muscle care.",
  },
  {
    icon: service2,
    title: "Compression",
    desc: "Reduces inflammation and soothes tired muscles with guided compression therapy.",
  },
  {
    icon: service3,
    title: "Vibro Heating",
    desc: "Improves mobility and speeds up muscle recovery with vibration heat therapy.",
  },
  {
    icon: service4,
    title: "Ice Box",
    desc: "Boosts recovery and performance with contrast ice bath sessions.",
  },
];

export default function ServicesSection() {
  return (
    <section id="hl-services" className="hl-services">
      <div className="hl-services__card">
        {SERVICES.map((s) => (
          <div className="hl-service" key={s.title}>
            <span className="hl-service__icon">
              <img src={s.icon} alt={s.title} />
            </span>
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
